export default __webpack_public_path__ + "static/media/home-guardian-logo-full.920ef463.png";